module.exports = __webpack_public_path__ + "static/media/iconMessagesActive.de64399c.svg";